import { Sidebar } from '@supply-mover-2-0/web-ui';
import React from 'react';

type PortalSidebarProps = Omit<
	React.ComponentProps<typeof Sidebar>,
	| 'panelClassName'
	| 'dividerClassName'
	| 'closeButtonClassName'
	| 'resizeHandleClassName'
>;

/**
 * The shared Sidebar painted in the storefront's brand tokens.
 *
 * The shared component styles itself from the CRM theme, which knows nothing
 * about a tenant's brand: against a branded page its panel read as a
 * different product (PD-15016), and once the panel was fixed its chrome —
 * the close (X) button, the header divider and the resize grip — still came
 * out in three unrelated CRM grays on a brand-tinted dark panel (PD-15974).
 * Every storefront sidebar goes through this wrapper so the overrides live
 * in one place:
 *
 *   - panel: `bg-brand-surface`, the card surface.
 *   - divider: `brand-border`, the same edge every card and input on the
 *     page already carries, so the panel's seams match the containers
 *     around it in both themes.
 *   - resize grip: `brand-input`, the recessed input tint, so the 8px band
 *     reads as a groove at the panel's edge rather than a stripe; it lifts
 *     to the border tint on hover.
 *   - close button: `text-default`, the same ink as the panel title — white
 *     on the dark panel, near-black on the light one — with the input tint
 *     on hover.
 */
export const PortalSidebar: React.FC<PortalSidebarProps> = (props) => (
	<Sidebar
		{...props}
		panelClassName="bg-brand-surface"
		dividerClassName="border-brand-border"
		closeButtonClassName="text-default hover:bg-brand-input"
		resizeHandleClassName="bg-brand-input hover:bg-brand-border"
	/>
);
